import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import styled from 'styled-components';

import { theme } from '../../common/ui/theme';

export const DropdownMenuContent = styled(RadixDropdownMenu.Content)<{ $width?: number }>`
    padding: ${theme.space[4]};
    background: ${theme.colors.background.default};
    border-radius: ${theme.radii[8]};
    border: 1px solid ${theme.colors.border.muted};
    box-shadow: ${theme.shadows.large};
    width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
    max-width: 320px;
    box-sizing: border-box;
    z-index: ${theme.zIndex.interactive};

    [data-radix-dropdown-menu-separator] {
        height: 1px;
        background: ${theme.colors.border.muted};
        margin: ${theme.space[4]} ${theme.space[8]};
    }
`;
